<template>
  <lf-card class="mb-8 max-w-screen-md py-6" data-cy="byocTab">
    <loader :isLoading="isSubmitting" />
    <form @submit.prevent="submit">
      <div class="space-y-5 pb-2 pt-8">
        <lf-switch
          name="data.can_manage_client_credentials"
          v-model="initialValues.data.can_manage_client_credentials"
          content-class="mr-2"
        >
          <lf-h3>
            {{ $t("ORGANIZATION.BYOC.ENABLE") }}
          </lf-h3>
          <span class="mt-2">
            {{ $t("ORGANIZATION.BYOC.ENABLE_SUBTITLE") }}
          </span>
        </lf-switch>
      </div>
      <div
        class="mt-5 flex min-w-full items-center justify-end border-t py-6 pr-5"
      >
        <primary-button
          type="submit"
          :disabled="isSubmitting"
          data-cy="byocTabSubmit"
        >
          {{ $t("ORGANIZATION.API_CONFIG.SAVE_CHANGES") }}
        </primary-button>
      </div>
    </form>
  </lf-card>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useForm } from "vee-validate";
import { dispatchAction } from "@/helpers/vee-validate";
import { useClients } from "@/hooks/clients";

const { activeClient } = useClients();

const initialValues = reactive({
  data: {
    can_manage_client_credentials:
      !!activeClient.value?.can_manage_client_credentials
  }
});

const { handleSubmit, isSubmitting } = useForm({
  initialValues
});

const submit = handleSubmit(async (values, actions) => {
  await dispatchAction(values, actions, "clients/updateClient");
});
</script>
